import { useState } from "react";
import { Check, ChevronDown, X } from "lucide-react";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";

export function TagList({ items, testid, empty = "—" }) {
  if (!items?.length) return <span className="text-slate-400">{empty}</span>;
  return (
    <span className="inline-flex flex-wrap gap-1" data-testid={testid}>
      {items.map((t) => <span key={t} className="text-xs px-2 py-0.5 rounded-full bg-cyan-50 border border-cyan-200 text-cyan-800">{t}</span>)}
    </span>
  );
}

export function MultiTagSelect({ options, value, onChange, placeholder, testid }) {
  const [open, setOpen] = useState(false);
  const toggle = (o) => onChange(value.includes(o) ? value.filter((v) => v !== o) : options.filter((x) => x === o || value.includes(x)));
  return (
    <div className="space-y-1.5">
      <Popover open={open} onOpenChange={setOpen} modal>
        <PopoverTrigger asChild>
          <button type="button" className="w-full flex items-center justify-between h-9 px-3 rounded-md border border-input bg-white text-sm text-left" data-testid={testid}>
            <span className={value.length ? "text-slate-800" : "text-slate-400"}>{value.length ? `${value.length} selected` : placeholder}</span>
            <ChevronDown className="w-4 h-4 text-slate-400" />
          </button>
        </PopoverTrigger>
        <PopoverContent className="p-1 w-[--radix-popover-trigger-width] max-h-72 overflow-y-auto" align="start">
          {options.map((o) => (
            <button type="button" key={o} onClick={() => toggle(o)} className="w-full flex items-center gap-2 px-2 py-1.5 text-sm rounded hover:bg-slate-50 text-left"
              data-testid={`${testid}-option-${o.replace(/[^a-z0-9]+/gi, "-").toLowerCase()}`}>
              <span className={`w-4 h-4 rounded border flex items-center justify-center ${value.includes(o) ? "bg-[#0b192c] border-[#0b192c] text-white" : "border-slate-300"}`}>
                {value.includes(o) && <Check className="w-3 h-3" />}
              </span>
              {o}
            </button>
          ))}
        </PopoverContent>
      </Popover>
      {value.length > 0 && (
        <div className="flex flex-wrap gap-1" data-testid={`${testid}-tags`}>
          {value.map((v) => (
            <span key={v} className="inline-flex items-center gap-1 text-xs pl-2 pr-1 py-0.5 rounded-full bg-cyan-50 border border-cyan-200 text-cyan-800">
              {v}
              <button type="button" onClick={() => toggle(v)} aria-label={`Remove ${v}`} data-testid={`${testid}-remove-${v.replace(/[^a-z0-9]+/gi, "-").toLowerCase()}`}><X className="w-3 h-3" /></button>
            </span>
          ))}
        </div>
      )}
    </div>
  );
}
